import Cards from "./Cards";
export default function HistoryContribution({ setTab }) {
  return (
    <div>
      <h3 className="text-2xl font-bold mb-3">History {"&"} Contributions</h3>
      <div className="border-l-2 pt-6 border-dashed border-gray-200 ml-1 card-lists">
        {[1, 1, 1, 1].map((card, index) => (
          <Cards key={`history-${index}`} />
        ))}
      </div>
      <div className="flex items-start max-w-xs mx-auto mt-10">
        <button
          className="ml-auto text-sm font-bold rounded-md px-12 py-3 transition bg-yellow-400 text-white mb-5 w-full mt-5"
          type="button"
          onClick={() => setTab("Add Source")}
        >
          Add New Source to this Case
        </button>
      </div>
    </div>
  );
}
